import { openBlock, createElementBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [
    createElementVNode("g", { "clip-path": "url(#clip0_15324_4065)" }, [
      createElementVNode("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        d: "m6 4 4 4-4 4"
      })
    ], -1),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_15324_4065" }, [
        createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h16v16H0z"
        })
      ])
    ], -1)
  ])]);
}
const ChevronRightIcon = { render };
export {
  ChevronRightIcon as default,
  render
};
//# sourceMappingURL=chevron-right.svg.js.map
